'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function cbDisclaimerService($http) {
    var vm = this;

    vm.getText = function (url) {
        return $http.get(url);
    };
}

cbDisclaimerService.$inject = ['$http'];

exports.default = cbDisclaimerService;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/disclaimer/cb-disclaimer.service.js
// module id = 413
// module chunks = 0